export const replaceStringByRules = (str: string, rules: string[][]) => {
  let result = str;
  rules.forEach((rule: string[]) => {
    result = result.replace(rule[0], rule[1]);
  });
  return result;
};
